import { PUZZLE_LENGTH } from '@wt/app/game/_components/PuzzleLoader';
import { nullFunc } from '@wt/utilities/nullFunction';
import React, { createContext, ReactNode, useContext, useState } from 'react';

interface ImageModalOpenContextType {
  imageModalOpen: boolean[];
  setImageModalOpen: (v: boolean, i: number) => void;
}

const initialContextValue: ImageModalOpenContextType = {
  imageModalOpen: Array.from(Array(PUZZLE_LENGTH), () => false),
  setImageModalOpen: nullFunc,
};

const ImageModalOpenContext =
  createContext<ImageModalOpenContextType>(initialContextValue);

export const useImageModalOpen = () => useContext(ImageModalOpenContext);

export const ImageModalOpenProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [imageModalOpen, setImageModalOpen] = useState<boolean[]>(
    Array.from(Array(PUZZLE_LENGTH), () => false)
  );

  const setImageModalOpenWrapper = (v: boolean, i: number) => {
    const newValues = [...imageModalOpen];
    newValues.splice(i, 1, v);
    setImageModalOpen(newValues);
  };

  return (
    <ImageModalOpenContext.Provider
      value={{ imageModalOpen, setImageModalOpen: setImageModalOpenWrapper }}
    >
      {children}
    </ImageModalOpenContext.Provider>
  );
};
